import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "app-professional-manager-account-details",
  templateUrl: "./professional-manager-account-details.component.html",
  styleUrls: ["./professional-manager-account-details.component.scss"],
})
export class ProfessionalManagerAccountDetailsComponent implements OnInit {
  @Input() public account;
  @Output() public userOutputValue = new EventEmitter();
  @Output() public onClick = new EventEmitter();
  public showDetailUser: boolean;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService
  ) {}

  ngOnInit() {
    this.showDetailUser = false;
  }

  goBack(): void {
    this.showDetailUser = false;
    this.onClick.emit();
  }
}
